export default __webpack_public_path__ + "static/media/titon.58780b64.svg";